export enum GameAnalyticsGame {
  MolloPuzz = 'MolloPuzz',
  ComeToTerms = 'ComeToTerms',
  DealEmWell = 'DealEmWell',
  GetTheBest = 'GetTheBest',
  RoxNRoll = 'RoxNRoll',
  HoverRush = 'HoverRush',
  WellnessTrek = 'WellnessTrek',
  BringIt = 'BringIt',
}

export enum GameAnalyticsSurvey {
  ComprehensionSurvey = 'ComprehensionSurvey',
}

export const GAME_ANALYTICS_GAMES = Object.values(GameAnalyticsGame);

export const GAME_ANALYTICS_SURVEYS = Object.values(GameAnalyticsSurvey);

export interface ProgramHealth {
  active7d: number;
  avgScore: number;
  active21d: number;
  activePct7d: number;
  organization: string;
  neverStarted: number;
  totalSessions: number;
  avgPassedCount: number;
  enrolledPlayers: number;
  playersWithSessions: number;
}

export interface GameAnalyticsPlayer {
  email: string;
  userId: string;
  player: string;
  organization: string;
  lifetimeSessions: number;
  lastActive: string | null;
  daysSinceActive: number | null;
  status: GameAnalyticsPlayerStatus;
}

export enum GameAnalyticsPlayerStatus {
  ACTIVE = 'ACTIVE',
  AT_RISK = 'AT_RISK',
  INACTIVE = 'INACTIVE',
  NEVER_STARTED = 'NEVER_STARTED',
}

export interface GameAnalyticsGameScore {
  players: number;
  avgTime: number;
  sessions: number;
  avgScore: number;
  avgPassedCount: number;
  game: GameAnalyticsGame;
}

export interface GameAnalyticsStatusCounts {
  active: number;
  atRisk: number;
  inactive: number;
  neverStarted: number;
}

export interface GameAnalyticsSummary {
  followUpTotal: number;
  programHealth: ProgramHealth | null;
  scoreByGame: GameAnalyticsGameScore[];
  followUpPlayers: GameAnalyticsPlayer[];
  statusCounts: GameAnalyticsStatusCounts;
}

export type GameAnalyticsDetailKind =
  Uncapitalize<GameAnalyticsGame> | Uncapitalize<GameAnalyticsSurvey>;

export interface ReportColumnType {
  key: string;
  header: string;
  type:
    | 'date'
    | 'string'
    | 'number'
    | 'status'
    | 'boolean'
    | 'dateTime'
    | 'percentage'
    | 'difficulty'
    | 'correctness'
    | 'passedCount'
    | 'durationSeconds';
}

export interface TypedReportTable {
  total: number;
  columns: ReportColumnType[];
  rows: (string | number | boolean | null)[][];
}

export interface GameAnalyticsRequest {
  limit?: number;
  offset?: number;
  sortBy?: string;
  search?: string;
  userId?: string;
  tenantId: string;
  gameName?: string;
  timezone?: string;
  occurredTo?: string;
  occurredFrom?: string;
}

export interface GameAnalyticsDetailsRequest extends GameAnalyticsRequest {
  kind: GameAnalyticsDetailKind;
}
